
import { io } from 'socket.io-client';

const SOCKET_URL = process.env.REACT_APP_SOCKET_URL ||
  (process.env.NODE_ENV === 'production'
    ? 'https://api.pesacore.fr'
    : 'https://localhost:5000');

class PesaSocket {
  constructor() {
    this.socket    = null;
    this.connected = false;
    this.listeners = new Map();
  }

  connect() {
    if (this.socket?.connected) return;
    if (this.socket) { this.socket.disconnect(); this.socket = null; }

    this.socket = io(`${SOCKET_URL}/pesa`, {
      withCredentials: true,
      transports: process.env.NODE_ENV === 'development' ? ['polling'] : ['polling', 'websocket'],
      reconnection: true,
      reconnectionAttempts: 10,
      reconnectionDelay: 1000,
    });

    this.socket.on('connect', () => {
      console.log('[PESA] Connecté:', this.socket.id);
      this.connected = true;
      this._emit('connected');
    });

    this.socket.on('connect_error', (err) => {
      console.error('[PESA] Erreur connexion:', err.message);
      this.connected = false;
      this._emit('connect_error', err);
    });

    this.socket.on('disconnect', (reason) => {
      console.log('[PESA] Déconnecté:', reason);
      this.connected = false;
      this._emit('disconnect', reason);
    });

    this.socket.on('state-updated', (state) => this._emit('state-updated', state));
  }

  disconnect() {
    this.socket?.disconnect();
    this.socket    = null;
    this.connected = false;
  }

  emit(event, data) { this.socket?.emit(event, data); }

  joinCase(caseId)              { this.socket?.emit('join-case', caseId); }
  updateState(caseId, state)    { this.socket?.emit('update-state', { caseId, state }); }

  on(event, cb) {
    if (!this.listeners.has(event)) this.listeners.set(event, []);
    this.listeners.get(event).push(cb);
    return () => this.off(event, cb);
  }

  off(event, cb) {
    this.listeners.set(event, (this.listeners.get(event) || []).filter(c => c !== cb));
  }

  _emit(event, data) {
    (this.listeners.get(event) || []).forEach(cb => { try { cb(data); } catch (e) { console.error(e); } });
  }
}

const pesaSocket = new PesaSocket();
export default pesaSocket;